<template lang="pug">
.video-container
  video(
    ref="player"
    class="video-js vjs-city-offer minimalistic"
    controls
    playsinline
    crossorigin
  )
    source(:src="src" :type="mime")
</template>

<script>
import { get, trim } from '@/helpers';

import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';

// import Hls from 'hls.js';
// import Plyr from 'plyr';

export default {
    name: 'VideoPlayer',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            player: null
        };
    },
    watch: {
        src(fresh, old) {
            if (old && fresh !== old && this.player) {
                this.player.pause();
                this.player.src([
                    {
                        type: this.mime,
                        src: this.src
                    }
                ]);
                // this.initialise()
                this.player.load();
                this.player.play();
            }
        }
    },
    computed: {
        isHls() {
            return !!get(this.data, 'hls');
        },
        mime() {
            if (this.isHls) {
                return this.data.hls.mime;
            } else {
                return this.data.source.mime;
            }
        },
        src() {
            let src;
            if (this.data) {
                // if (this.isHls) {
                //   src = `${cdnEndpoint}/${this.data.hls.path}/${this.data.hls.name}`;
                // } else {
                //   src = `${cdnEndpoint}/${this.data.source.path}/${this.data.source.name}`;
                // }

                const storageRoute = trim(
                    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                    '/'
                );

                if (this.isHls) {
                    // src = `${storageRoute}/videos/${this.data.id}/${this.data.hls.name}`;

                    const cdnEndpoint = trim(
                        `${process.env.VUE_APP_CDN_HTTP}${process.env.VUE_APP_CDN_ENDPOINT}${process.env
                            .VUE_APP_CDN_ROOT || ''}`,
                        '/'
                    );

                    src = `${cdnEndpoint}/${this.data.hls.path}/${this.data.hls.name}`;
                } else {
                    src = `${storageRoute}/videos/${this.data.id}/${this.data.source.name}`;
                }
            }
            // this.activeProductMedia.data.hls
            return src;
        }
    },
    methods: {
        initialise() {
            // TODO
            // const video = this.$refs.player;
            // // const player = new Plyr(video);
            // const source = this.src;

            // // For more options see: https://github.com/sampotts/plyr/#options
            // // captions.update is required for captions to work with hls.js
            // const options = {};

            // const updateQuality = newQuality => {
            //   window.hls.levels.forEach((level, levelIndex) => {
            //     if (level.height === newQuality) {
            //       console.log("Found quality match with " + newQuality);
            //       window.hls.currentLevel = levelIndex;
            //     }
            //   });
            // }

            // if (this.isHls && Hls.isSupported()) {
            //   // For more Hls.js options, see https://github.com/dailymotion/hls.js
            //   const hls = new Hls();
            //   hls.loadSource(source);

            //   // From the m3u8 playlist, hls parses the manifest and returns
            //   // all available video qualities. This is important, in this approach,
            //   // we will have one source on the Plyr player.
            //   hls.on(Hls.Events.MANIFEST_PARSED, function () {
            //     const availableQualities = hls.levels.map((l) => l.height)
            //     availableQualities.unshift(0) //prepend 0 to quality array
            //     options.quality = {
            //       default: 0, //Default - AUTO
            //       options: availableQualities,
            //       forced: true,
            //       onChange: (e) => updateQuality(e),
            //     }
            //     hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
            //       var xpath = "//button[@data-plyr='settings']/span[text()='Quality']/span[@class='plyr__menu__value']";
            //       var label = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

            //       var span = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span")
            //       if (hls.autoLevelEnabled) {
            //         span.innerHTML = `AUTO (${hls.levels[data.level].height}p)`
            //         label.innerHTML = `AUTO (${hls.levels[data.level].height}p)`
            //       } else {
            //         span.innerHTML = `AUTO`
            //         label.innerHTML = `${hls.levels[data.level].height}p`
            //       }
            //     })
            //     const player = new Plyr(video, options);
            //     console.log(player);
            //   })
            //   hls.attachMedia(video);
            //   window.hls = hls;
            // } else {
            //   // default options with no quality update in case Hls is not supported
            //   new Plyr(video, options);
            // }

            const options = {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: true,
                aspectRatio: '9:16',
                autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                },
                controlBar: {
                    pictureInPictureToggle: false
                }
                // plugins: {
                //   hlsQualitySelector: {
                //     displayCurrentQuality: true,
                //   }
                // }
            };
            this.player = videojs(this.$refs.player, options);
            this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            });

            this.player.on('touchstart', event => {
                // this.$refs.player.parentNode.classList.add('vjs-show-controls');
                if (event.target.nodeName === 'VIDEO') {
                    if (this.player.paused()) this.player.play();
                    else this.player.pause();
                }
            });

            videojs.log.level('error');
        }
    },
    mounted() {
        this.initialise();
    },
    beforeDestroy() {
        if (this.player) this.player.dispose();
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
.video-container
  position: fixed
  right: 0
  top: 0
  ::v-deep .video-js
    .vjs-http-source-selector .vjs-menu
      width: 60px !important
      left: -30px !important
</style>
